import { thinkificConstants } from "../../constants";

export function thinkific(state={}, action) {
  const {
    discountCodes,
  } = state;
  switch (action.type) {
    case thinkificConstants.LIST_DISCOUNT_CODES_REQUEST:
      return { isListingDiscountCodes: true };
    case thinkificConstants.LIST_DISCOUNT_CODES_SUCCESS:
      return { discountCodes: action.payload.data };
    case thinkificConstants.LIST_DISCOUNT_CODES_FAILURE:
      return {};
    case thinkificConstants.CREATE_DISCOUNT_CODES_REQUEST:
      return { isCreatingDiscountCodes: true };
    case thinkificConstants.CREATE_DISCOUNT_CODES_SUCCESS:
      return { discountCodes: action.payload.data };
    case thinkificConstants.CREATE_DISCOUNT_CODES_FAILURE:
      return { discountCodes };
    default:
      return state;
  }
}